 <!--==========================
      Contact Section
    ============================-->
    <section id="contact">
      <div class="container-fluid">

        <div class="section-header">
          <h1 style="text-align: center;">Contact Us</h1>
        </div>

        <div class="row wow fadeInUp">

          <div style="margin: auto;width: 60%">
            <div class="row" >
              <div class="col-lg-5 info">
                <i class="ion-ios-location-outline"></i>
                <p>502 Palisade Ave, NJ 07307</p>
              </div>
              <div class="col-lg-3 info">
                <i class="ion-ios-email-outline"></i>
                <p>info@shreemon.com</p>
              </div>
              <div class="col-lg-4 info">
                <i class="ion-ios-telephone-outline"></i>
                <p>+1(201) 564-0454</p>
              </div>
            </div>

            <div class="form">
              <div id="sendmessage">Your message has been sent. Thank you!</div>
              <div id="errormessage"></div>
              <form [formGroup]="contactForm" (ngSubmit)="onSubmit(contactForm)" novalidate>
                <div class="form-row">
                  <div class="form-group col-lg-6">
                    <input type="text" name="name" class="form-control" id="name" placeholder="Your Name" data-rule="minlen:4"  formControlName="name" required/>
                    <div class="validation"></div>
                  </div>
                  <div class="form-group col-lg-6">
                    <input type="email" class="form-control" name="email" id="email" placeholder="Your Email" data-rule="email" formControlName="email" required />
                    <div class="validation"></div>
                  </div>
                </div>
                <div class="form-group">
                  <input type="text" class="form-control" name="subject" id="subject" placeholder="Subject" formControlName="subject" required  />
                  <div class="validation"></div>
                </div>
                <div class="form-group">
                  <textarea class="form-control" name="message" rows="5" data-rule="required"  placeholder="Message" formControlName="message" required></textarea>
                  <div class="validation"></div>
                </div>
                <div class="text-center"><button type="submit" title="Send Message">Send Message</button></div>
                <div class="text-center">{{result}}</div>
              </form>
            </div>
          </div>

        </div>

      </div>
    </section><!-- #contact -->